import { apiProductionMachines } from './apiProductionMachines'
import { apiProductionMachineTypes } from './apiProductionMachineTypes'
import { apiProductionProductTypes } from './apiProductionProductTypes'
import { apiProductionSockets } from './apiProductionSockets'

const apiProductionGroup = {
	...apiProductionMachines,
	...apiProductionSockets,
	...apiProductionMachineTypes,
	...apiProductionProductTypes,
}

export { apiProductionGroup }
